import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ShimmerCircularImage = ({ size=80, center=false, className }) => {
  const style = {};
  if (size) {
    style.width = `${size}px`;
    style.height = `${size}px`;
  }

  return (
      <div
        style={style}
        className={classNames({
          'shimmer shimmer-avatar': true,
          [className]: className,
        })}></div>
  );
};

ShimmerCircularImage.propTypes = {
  size: PropTypes.number,
  center: PropTypes.bool,
  className: PropTypes.string,
};

export default ShimmerCircularImage;
